import * as React from "react";
import { DatePicker, DatePickerProps } from "@mui/x-date-pickers";

export function CustomDatePicker<TDate extends Date>(
  props: DatePickerProps<TDate, false>,
) {
  const [openDate, setOpenDate] = React.useState<boolean>(false);

  // default textField slot props we want to ensure
  const defaultTextField = {
    fullWidth: true,
    variant: "outlined" as const,
    InputLabelProps: { shrink: true as const },
    sx: {
      "& .MuiInputBase-input": {
        fontSize: "14px",
      },
      "& input::placeholder": {
        fontSize: "12px",
        opacity: 1,
      },
    },
  };

  const handleOpenDatePicker = () => {
    setOpenDate(true);
  };

  const handleCloseDatePicker = () => {
    setOpenDate(false);
  };

  // merge user's slotProps.textField if present
  const mergedSlotProps = {
    ...(props.slotProps ?? {}),
    textField: {
      ...(defaultTextField as Record<string, unknown>),
      ...(props.slotProps?.textField ?? {}),
      sx: {
        ...(defaultTextField.sx ?? {}),
        ...((props.slotProps?.textField as any)?.sx ?? {}),
      },
      onClick: handleOpenDatePicker,
    },
  };

  return (
    <DatePicker
      {...(props as unknown as Record<string, unknown>)}
      slotProps={
        mergedSlotProps as unknown as DatePickerProps<TDate, false>["slotProps"]
      }
      open={openDate}
      onOpen={handleOpenDatePicker}
      onClose={handleCloseDatePicker}
    />
  );
}

export default CustomDatePicker;
